<template>
  <div>
    <div class="md-layout">
      <f-field label="Fecha de orden" :value="purchaseOrder.addDate"></f-field>
      <f-field label="Fecha de entrega" :value="purchaseOrder.deliveryDate"></f-field>
      <f-field label="Condiciones de entrega" :value="purchaseOrder.sendConditions"></f-field>
      <f-field label="Condiciones de pago" :value="purchaseOrder.paymentConditions"></f-field>
    </div>
    <div
      v-if="purchaseOrder.campName || purchaseOrder.campAddress"
      class="md-layout md-alignment-top-right"
    >
      <div class="md-layout-item md-size-70">
        <f-field v-if="purchaseOrder.campName" label="Campamento" :value="purchaseOrder.campName"></f-field>
        <f-field
          v-if="purchaseOrder.campAddress"
          label="Dirección"
          :value="purchaseOrder.campAddress"
          :size="50"
        ></f-field>
      </div>
    </div>
    <KDraggableField :value="invoices" :allowedFormats="['pdf', 'xml']" @input="validateFiles" />
    <invoiceManager
      :value="invoicesGroups"
      @removeFile="removeFile"
      @removeInvoice="removeInvoice"
    />
    <div class="md-layout md-align-end">
      <md-button :disabled="missingFiles" @click="submitInvoices">Enviar facturas</md-button>
    </div>
  </div>
</template>

<script>
// COMPONENTS
import KDraggableField from "@/components/Inputs/KDraggableField";
import invoiceManager from "./invoiceManager";

// Utils
import FField from "../Quotations/FField";

export default {
  name: "PurchaseOrderInvoiceLoader",
  components: { FField, KDraggableField, invoiceManager },
  props: {
    purchaseOrder: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      invoices: [],
      // invoicesGroups: [],
    };
  },
  computed: {
    invoicesGroups() {
      if (!!this.invoices.length) {
        const groups = this.invoices.reduce((ac, file) => {
          const iteratorName = file.name.split(".").shift();
          const format = file.name.split(".").pop().toUpperCase();

          let item = {
            uuid: null,
            PDF: null,
            XML: null,
          };
          const index = ac.findIndex((invoice) =>
            invoice.uuid.includes(iteratorName)
          );
          if (index > -1) {
            ac[index][format] = file;
            return [...ac];
          }
          item.uuid = iteratorName;
          item[format] = file;
          return [...ac, { ...item }];
        }, []);

        return groups;
      }
      return [];
    },
    missingFiles() {
      return (
        this.invoicesGroups.some(({ PDF, XML }) => !PDF || !XML) ||
        !this.invoicesGroups.length
      );
    },
  },
  methods: {
    removeFile(file) {
      this.invoices = this.invoices.filter(({ name }) => name !== file.name);
    },
    removeInvoice(invoice) {
      this.invoices = this.invoices.filter(({ name }) => {
        const fileName = name.split(".").shift();
        return fileName === invoice.uuid;
      });
    },
    submitInvoices() {
      this.$emit("submitInvoices", this.invoicesGroups);
    },
    validateFiles(files) {
      let filteredFiles = [];
      files.forEach((file) => {
        const index = this.invoices.findIndex(
          (invoice) => invoice.name === file.name
        );
        if (index > -1) {
          this.invoices.slice(index, 1, file);
        } else {
          filteredFiles.push(file);
        }
      });
      this.invoices = [...this.invoices, ...filteredFiles];
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/PurchaseOrderTracking/PurchaseOrderInvoiceLoader.vue